import {database} from "../../../../config/firebase";
import {asyncActionError, asyncActionFinish, asyncActionStart} from "../../../async/AsyncActions";
import {
    ADD_POSTS,
    GROUP_POSTS_FETCH_SUCCESS,
    NO_MORE_POSTS,
    RESET_REDUCER_STATE,
    SET_GROUP_SCROLL_POSITION
} from "../../../../actions/types";
import {fetcher} from "../../../../utilities/utils";
import {toastr} from 'react-redux-toastr'
import {ref, runTransaction} from "firebase/database";
import * as Sentry from "@sentry/node";

export const toggleFollowGroup = async (groupId, userId) => {

    const groupPath = '/groups/' + groupId
    const groupRef = ref(database, groupPath)

    await runTransaction(groupRef, function (group) {
        if (group) {
            if (group.m && group.m[userId]) {
                group.m[userId] = null;
                toastr.warning('Unsubscribed', 'We are sorry to see you leave '.concat(group.n))
            } else {
                if (!group.m) {
                    group.m = {};
                }
                group.m[userId] = true;
                toastr.success('Welcome onboard', 'You are now subscribed to '.concat(group.n))
            }
        }
        return group;
    });


};

export const getGroupPosts = (isRefresh, groupId) => async (dispatch, getState) => {
    if (!getState().async.loading) {
        try {
            dispatch(asyncActionStart());
            let lastVisibleCursor = getState().group.lastPostCursor;
            const baseUrl = `https://naija-world-1c442.web.app/api/groupPosts?groupId=${groupId}`;
            const url = isRefresh ? baseUrl : `${baseUrl}&cursor=${lastVisibleCursor}`;

            const response = await fetcher(url) || [];
            const {data: posts, nextCursor: cursor} = response;

            if (posts.length > 0) {
                dispatch({type: ADD_POSTS, payload: posts});
                dispatch({type: GROUP_POSTS_FETCH_SUCCESS, cursor, hasMore: Boolean(cursor)});
            } else {
                dispatch({type: NO_MORE_POSTS})
            }
            dispatch(asyncActionFinish());
        } catch (error) {
            Sentry.captureException(error);
            dispatch(asyncActionError());
        }
    }
};

export const resetState = () => async (dispatch) => {
    dispatch({type: RESET_REDUCER_STATE})
};

export const setScrollPosition = scrollPosition => async (dispatch) => {
    dispatch({
        type: SET_GROUP_SCROLL_POSITION,
        value: scrollPosition
    });
};